import { render, staticRenderFns } from "./ResourceAppointmentCard.vue?vue&type=template&id=06265976&"
import script from "./ResourceAppointmentCard.vue?vue&type=script&lang=js&"
export * from "./ResourceAppointmentCard.vue?vue&type=script&lang=js&"
import style0 from "./ResourceAppointmentCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports